exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cancel-final-modal p[data-v-80c64c90] {\n  padding: 1.5em 1em 3em;\n}\n", ""]);

// exports
